import gql from 'graphql-tag';

export const getSubmissionVisitors = gql(`
  query GetSubmissionVisitors($filter: SubmissionVisitorFilterInput!) {
    submissionVisitors(filter: $filter) {
      submissionVisitors {
        id
        visitorPass {
          visitor {
            firstName
            lastName
            company
            email
            phone
          }
          hostName
          host {
            profile {
              email
              phone
              image
            }
          }
          tenantName
          tenant {
            name
            address {
              street1
              street2
              city
              state
            }
            profile {
              logo
              image
            }
          }
          floor
          startDatetime
          endDatetime
        }
        recurrence {
          recurrenceId
          schedule
          scheduleDuration
        }
        watchlists {
          id
          organizationId
          visitorMatchingInfo {
            firstName {
              primaryValue
              alternateValues
              matchType
            }
            lastName {
              primaryValue
              alternateValues
              matchType
            }
            email {
              primaryValue
              alternateValues
              matchType
            }
            phone {
              primaryValue
              alternateValues
              matchType
            }
          }
          severityLevel
          notes
          attachmentIds
        }
      }
      totalCount
    }
  }
`);
